import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faEnvelope
} from '@fortawesome/free-solid-svg-icons';
import {
  faXTwitter,
  faInstagram,
  faSnapchatGhost,
  faWhatsapp
} from '@fortawesome/free-brands-svg-icons';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-6 w-full">

      <div className="flex flex-row flex-wrap justify-center gap-20 text-2xl">
        <a href="https://x.com/saadaty107" target="_blank" rel="noopener noreferrer" title="X / Twitter" className="hover:text-blue-500">
          <FontAwesomeIcon icon={faXTwitter} />
        </a>
        <a href="https://instagram.com/saadaty1007" target="_blank" rel="noopener noreferrer" title="Instagram" className="hover:text-pink-500">
          <FontAwesomeIcon icon={faInstagram} />
        </a>
        <a href="https://snapchat.com/add/saadaty107" target="_blank" rel="noopener noreferrer" title="Snapchat" className="hover:text-yellow-400">
          <FontAwesomeIcon icon={faSnapchatGhost} />
        </a>
        <a href="mailto:ceo@saadty.com" title="Email" className="hover:text-red-400">
          <FontAwesomeIcon icon={faEnvelope} />
        </a>
        <a href="https://wa.me/966503732107" target="_blank" rel="noopener noreferrer" title="WhatsApp" className="hover:text-green-400">
          <FontAwesomeIcon icon={faWhatsapp} />
        </a>
      </div>
    </footer>
  );
};

export default Footer;
